<div style="height: 100%;">
  <div class="container-fluid" style="height: 100%;">
    <div class="row align-items-center justify-content-start" style="height: 100%;">
        <div class="container">
            <div class="row">
                <div class="col-sm-10 d-flex align-items-center">
                    <img src="/Images/UnifocusLogo_Blue_Small.png" style="height:64px" />
                </div>
    
                <div class="col-sm-2 d-flex justify-content-end align-items-center" title="{{(sessionSignalR.connectionIsEstablished) ? ('NAV.NAV_CONNECTION_ICON_SUCCESS' | translate) : ('NAV.NAV_CONNECTION_ICON_ERROR' | translate)}}">
                        <i class="statusIcon" [ngClass]="(sessionSignalR.connectionIsEstablished) ? 'ksv-icon-connection-on statusIcon-Sucess': 'ksv-icon-connection-off statusIcon-Error'"></i>
                    </div>
                </div>
            <div class="row qr-code-container shadow-sm">
                <div class="col-md-8 instruction-box">
                    <div class="container col-md-12">

                        <h4 translate>TITLE.TITLE_KNOWCROSS_WEB_AUTH</h4>

                        <div>
                            <ul>
                                <li>
                                    <h5 translate>MSGTEXT.WEB_AUTH_PT_1</h5>
                                </li>
                                <li>
                                    <h5 translate>MSGTEXT.WEB_AUTH_PT_2</h5>
                                </li>
                                <li>
                                    <h5 translate>MSGTEXT.WEB_AUTH_PT_3</h5>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
                <div class="col-md-4 d-flex flex-column align-items-center justify-content-center">
                    <select class="custom-select"
                            id="PropertyId"
                            [hidden]="lstProperties.length == 1"
                            [(ngModel)]="SelectedPropertyId"
                            name="PropertyId"
                            (change)="onPropertyChange()">
                        <option *ngFor="let row of lstProperties"
                                [value]="row.PropertyId">
                            {{row.PropertyName}}
                        </option>
                    </select>
                    <ngx-qrcode [qrc-element-type]="elementType" [qrc-value]="qrData"></ngx-qrcode>
                </div>
            </div>
        </div>
    </div>
  </div>
</div>
